import { DatePipe } from "@angular/common";
import { Pipe, PipeTransform } from "@angular/core";
import { DateTime } from "luxon";

@Pipe({
  name: 'weekRange',
  pure: false,
  standalone: true
})
export class WeekRangePipe implements PipeTransform {
  constructor() {}

  transform(date: Date | DateTime): string {
    const value = date instanceof DateTime ? date : DateTime.fromJSDate(date);
    const start = value.startOf('week');
    const end = value.endOf('week');
    
    return `${start.toFormat('dd.MM')}-${end.toFormat('dd.MM')}`;
  }
}
